<template>
  <section
          class="page-container"
  >
    <ArticleCard
            :class="{ 'ms-auto': odd, 'me-auto': !odd }"
            :image-dimensions="imageDimensions"
            :image-sizes="imageSizes"
            :odd="odd"
            :page="page"
            class="tablet:max-w-[80%] desktop:max-w-[70%]"
    />
  </section>
</template>
<script lang="ts" setup>
import ArticleCard from "~/components/article/ArticleCard.vue";
import type {PageCollectionItemBase} from "@nuxt/content";

const {
    page,
    odd,
    imageDimensions = [{width: 2560}, {width: 1280}, {width: 640}],
    imageSizes = '100vw, (min-width: 768px) 40vw'
} = defineProps<{
    page: PageCollectionItemBase,
    odd: boolean,
    imageDimensions?: { width: number, height?: number }[],
    imageSizes?: string,
}>();
</script>